var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"home"},[_c('HeaderReturn',{attrs:{"title":"公告详情"}}),_c('div',{staticClass:"dataBox"},[_c('div',{staticStyle:{"margin-top":"10px","font-size":"18px"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.details.content)}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }